/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Checkout_Meta_TitleInputs */

const es_gift_checkout_meta_title = /** @type {(inputs: Gift_Checkout_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar tarjeta regalo | Zarpar`)
};

const gl_gift_checkout_meta_title = /** @type {(inputs: Gift_Checkout_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar tarxeta agasallo | Zarpar`)
};

const en_gift_checkout_meta_title = /** @type {(inputs: Gift_Checkout_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy gift card | Zarpar`)
};

/**
* | output |
* | --- |
* | "Buy gift card \| Zarpar" |
*
* @param {Gift_Checkout_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_checkout_meta_title = /** @type {((inputs?: Gift_Checkout_Meta_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Checkout_Meta_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_checkout_meta_title(inputs)
	if (locale === "en") return en_gift_checkout_meta_title(inputs)
	return es_gift_checkout_meta_title(inputs)
});